import classnames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
const ImageViewer = ({ fileUrl, style, className, alt = 'Preview' }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const handleImageLoad = () => {
        setIsLoading(false);
    };
    const imageClasses = classnames(className, {
        hidden: isLoading,
        block: !isLoading,
    });
    return (React.createElement(React.Fragment, null,
        isLoading && (React.createElement("div", { "data-testid": "div-5e6ee165" }, titleize(t('LOADING')))),
        React.createElement("img", { "data-testid": "img-590d42c3", src: fileUrl, alt: alt, className: imageClasses, onLoad: handleImageLoad, style: style })));
};
export default ImageViewer;
